import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    text-align: center;
    background-image: url('/images/about/about-contact-bg.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 5em 0;

    .subtitle {
        font-size: 1.1em;
        margin-bottom: 2em;
    }

    .title {
        font-size: 2em;
        font-weight: 600;
        margin-bottom: 1em;
    }

    .button-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;

        .button {
            margin: 1em;
            font-weight: 600;

            .layout-button {
                button {
                    background: none;
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletS}) {
        .title {
            font-size: 1.6em;
        }

        .button-wrapper {
            flex-direction: column;

            .button {
                width: 100%;
                margin: 0 0 1em 1em;

                .layout-button {
                    display: block;
                    width: 100%;

                    button {
                        font-size: .85em;
                        width: 90%;
                    }
                }
            }
        }
    }
`;